import { useContext, useEffect } from "react";
import { Container, DrowerMenu } from "./index";
import { useLocation } from "react-router-dom";
import { ContextAuth } from "../../context/ContextAuth";


export const Base = ({ children }: any) => {
    const CtxAuth = useContext(ContextAuth)
    const location = useLocation();

    const CheckUserInfo = () => {
        if (localStorage.getItem('user') && CtxAuth?.userInfo == null) {
            let userInfo = JSON.parse(String(localStorage.getItem('user')))
            CtxAuth.setUserInfo(userInfo)
            if (userInfo != null && localStorage.getItem('token')) {
                CtxAuth.setIsAuth(true)
            }
        }
    }

    useEffect(() => {
        CheckUserInfo()
    }, [location.pathname])

    return (
        <>
            <div className={`w-full relative flex flex-col items-center`} >
                <DrowerMenu />
                <Container />
            </div>
        </>
    );
}